import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/microsoft-365-backup-risk-check/RiskCheckClient.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
